import {
  GET_ALL_TENANTS_START, GET_ALL_TENANTS_SUCCESS, GET_ALL_TENANTS_FAIL,
  ADD_TENANT_START, ADD_TENANT_SUCCESS, ADD_TENANT_FAIL,
  UPDATE_TENANT_START, UPDATE_TENANT_SUCCESS, UPDATE_TENANT_FAIL,
  DELETE_TENANT_START, DELETE_TENANT_SUCCESS, DELETE_TENANT_FAIL,
} from '../constants/tenants';

const initialState = {
  isProcessing: false,
  isError: false,
  data: [],
};

function handleReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_TENANTS_START:
    case ADD_TENANT_START:
    case UPDATE_TENANT_START:
    case DELETE_TENANT_START:
      return { ...state, isProcessing: true, isError: false };

    case GET_ALL_TENANTS_FAIL:
    case ADD_TENANT_FAIL:
    case UPDATE_TENANT_FAIL:
    case DELETE_TENANT_FAIL:
      return { ...state, isProcessing: false, isError: true };

    case GET_ALL_TENANTS_SUCCESS:
      return { ...state, isProcessing: false, data: action.payload };

    case ADD_TENANT_SUCCESS:
      return { ...state, isProcessing: false, data: [...state.data, action.payload] };

    case UPDATE_TENANT_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        data: state.data.map((t) => (t.id === action.payload.id ? action.payload : t)),
      };

    case DELETE_TENANT_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        data: state.data.filter((t) => t.id !== action.payload),
      };

    default:
      return state;
  }
}

export const tenantsReducer = (state, action) => handleReducer(state, action);
